import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNota = (): TabelaColuna => ({
  Chave: 'nota',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 60 }}>Nota</div>
})
